import React from 'react';
import { Typography } from '@material-ui/core';

import LoadingAnimation from '../../../../../../../components/LoadingAnimation';
import { useStyles } from '../cancelConnectPlanDialog.styles';

function ProcessingStep () {
    const classes = useStyles();

    return (
        <div className={classes.processing}>
            <LoadingAnimation />
            <Typography className={classes.processingText}>
                Cancelling your subscription…
            </Typography>
        </div>
    );
}

export default ProcessingStep;
